import Configuration from "../../Configuration";
import { MediaFileProperties } from "core/models/Fragment";

export type MediaFileType =
    | "Selection"
    | "Intro"
    | "Outro"
    | "Overlay"
    | "Font"
    | "None"
    | "Xsl"
    | "";

export type MediaFileEntity = {
    id: number;
    projectId: number;
    channelId: number;
    type: MediaFileType;
    userProperties: {
        id: number;
        username: string;
    };
    name: string;
    key: string;
    taskId: number;
    processing: boolean;
    mediaFileProperties: MediaFileProperties;
    insertionDate: string;
    modifiedDate: string;
    expiryDate: string;
    temporary: boolean;
};

export class MediaFile {
    id: number;

    projectID: number;

    channelID: number;

    type: MediaFileType;

    author: {
        id: number;
        username: string;
    };

    name: string;

    key: string;

    taskID: number;

    isProcessing: boolean;

    mediaFileProperties: MediaFileProperties;

    insertionDate: Date;

    modifiedDate: Date;

    expiryDate: Date;

    temporary: boolean;

    constructor(entity: MediaFileEntity) {
        this.id = entity.id;
        this.projectID = entity.projectId;
        this.channelID = entity.channelId;
        this.type = entity.type;
        this.author = entity.userProperties;
        this.taskID = entity.taskId;
        this.isProcessing = entity.processing;
        this.mediaFileProperties = entity.mediaFileProperties;
        this.name = entity.name;
        this.key = entity.key;
        this.insertionDate = new Date(entity.insertionDate);
        this.modifiedDate = new Date(entity.modifiedDate);
        this.expiryDate = new Date(entity.expiryDate);
        this.temporary = entity.temporary;
    }

    getMediaURL = (): string => {
        const FILE_API_URL = Configuration.get("fileApiURL");
        const { fileProperties } = this.mediaFileProperties;
        return `${FILE_API_URL}/api/file/read/v1/t/p/${fileProperties.token}/${fileProperties.path}`;
    };

    getAspectRatio = (): string => {
        if (!this.mediaFileProperties) {
            return "unknown";
        }
        const { mediaProperties } = this.mediaFileProperties;
        if (!mediaProperties.videoAspectRatio) {
            return "unknown";
        }
        return mediaProperties.videoAspectRatio;
    };
}
